import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';
import { GroupAccountsPageComponent } from './group-accounts-page.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.groupAccountsAddUser.pageInRouting,
    data: { data: PAGES_AND_PATHS.groupAccountsAddUser },
    component: GroupAccountsPageComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./group-accounts-page.module').then(m => m.GroupAccountsPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupAccountsPageRoutingModule { }
